<template>
  <div>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24"> 
              <a-button @click="handleAdd()"> 新增对阵 <a-icon type="plus" /> </a-button>
              <a-button style="margin-left:10px;"  > 生成1/4决赛场次 </a-button>
          </a-col>  
          
        </a-row>
      </a-form>
    </div>
 

  </a-card>
  <div class="card-list" ref="content">   
    <div style="width:300px;background:#fff; margin:20px 0 0 0; padding:10px 0"> 
        <div v-for="(item,index) in options" :key="index" draggable="true" :xid="item.id" class="duiwu-item">
         <p style="font-size:16px; font-weight:bold">{{item.mingcheng}}</p>
          <p>{{item.yundongyuans}}</p>
        </div>
    </div>
        
        
    <a-card  style="overflow: scroll;margin:20px 0 0 20px">
      <svg :width="width"  :height="height"  >  
      
      <!-- 假设树只有一个根节点开始 -->  
      <TreeNode  
        v-for="(rootNode, index) in treeData"  
        :key="index"  
        :node="rootNode"  
        :x="width / 2"
        :y="0"  
        :level="0"  
        :levels="levels"
        :width="width"  
      />  
    </svg>  
    </a-card>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48"> 
            <a-col :md="12" :sm="24">
              <a-form-item 
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="层级数量"
                  extra="队伍数量=2的层级数量次方，比如层级数量3，队伍数量是8"
                  hasFeedback
              >
                <a-input-number  style="width:200px" :max="50" :min="1" v-decorator="[
          'count',
          {rules: [{ required: true, message: '请输入层级数量' }]}
        ]"
                         placeholder="请输入层级数量"/>
              </a-form-item> 
            </a-col> 
          </a-row>
        </a-form>
      </a-spin>
    </a-modal>
 
  
  </div>
  </div>
</template>

<script>
 
import TreeNode from "@/components/TreeNode.vue";
import {sjsqOptions, subjectOptions} from '@/api/sai'
import {
  vsTree,subjectForGroupOptions,setTreeNode,createVsTree
} from '@/api/vsscore'

  export default {
    name: 'AppList',
    components: { 
      TreeNode,
    },
    data () {
      return { 
        // SVG画布大小  

        //队伍级数 2的levels次方
        levels : 5,
        width: 2800,
        height: 1000 , 
        visible:false,
        saveLoading:false,
        sjsqOptions:[],
        options:[],
        form: this.$form.createForm(this),
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 12},
        },
        formData:{
          id:0,
          count:0,
        },
        queryParam:{
          sjsq:[
            0,637
          ]
        }, 
        duiwuList:[
          {
            'id' : 1,
            'mingcheng':'队伍1',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 2,
            'mingcheng':'队伍2',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 3,
            'mingcheng':'队伍3',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 4,
            'mingcheng':'队伍4',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 5,
            'mingcheng':'队伍5',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 6,
            'mingcheng':'队伍6',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 7,
            'mingcheng':'队伍7',
            'yundongyuans' :'张三  李四  王五'
          },
          {
            'id' : 8,
            'mingcheng':'队伍8',
            'yundongyuans' :'张三  李四  王五'
          },
        ], 
        treeData: [
        ],  
      }
    },

    mounted(){
      let that = this;

      that.getSjsqOptions();
      that.getOptions();
      // that.initTree();
      // setTimeout(() =>{
      //   that.initDrag()
      // },1000)
    },
    methods: {
          handleAdd() { 
            if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
              this.$message.error('请先选择赛区');
              return;
            }

            this.form.resetFields();
            this.visible = true
            this.formData.id = 0; 
            this.formData.saiqu = this.queryParam.sjsq[1]; 
      
          }, 
          initTree(){ 
            function generateTree(levels) {
              let idCounter = -1;
              function createNode(level, labelPrefix = '') {
                const node = {
                  id: idCounter--,
                  // id: 0,
                  // label: `${labelPrefix} ${level === 1 ? 'Root' : 'Child'} ${level > 1 ? level + '.' : ''}${idCounter - 1}`,
                  label: '-',
                  vs:[
                    {
                      id:0,
                      mingcheng:'空缺',
                    },
                    {
                      id:0,
                      mingcheng:'空缺',
                    }
                  ],
                  children: []
                };

                if (level < levels) {
                  for (let i = 0; i < 2; i++) { // 每个节点有两个子节点
                    const childNode = createNode(level + 1, node.label);
                    node.children.push(childNode);
                  }
                }

                return node;
              }

              return [createNode(1)];
            }



            // 使用示例：
            const treeData = generateTree(this.levels); // 生成具有3层的树 
            console.log('treeData',treeData);
            // this.treeData = treeData

            // updateNode(treeData, -5,1, {id:3,mingcheng:'哈哈22'});
            this.updateNode = updateNode;

            // this.width = Math.pow(2,this.levels-1)*140
            // this.height = 150*this.levels;
            // console.log('100*levels',100*levels)
          },


          updateNode(tree, id,index, newVal) {
            function findAndUpdate(node) {
              console.log('findAndUpdate',node.id,id)
              if (node.id == id) {
                node['mingcheng'+index] = newVal.mingcheng;
                node['subject_id'+index] = newVal.subject_id;
                return true;
              }

              for (let i = 0; i < node.children.length; i++) {
                if (findAndUpdate(node.children[i])) {
                  return true;
                }
              }

              return false;
            }

            // 遍历树的根节点
            for (let i = 0; i < tree.length; i++) {
              if (findAndUpdate(tree[i])) {
                return true;
              }
            }

            return false;
          },


          getSjsqOptions() {
            let that = this;
            sjsqOptions({
              saiqu:that.queryParam.sjsq[1]
            }).then(res => {
              that.sjsqOptions = res.data;
            });
          },
          getOptions() {
            let that = this;
            subjectForGroupOptions({
              saiqu:that.queryParam.sjsq[1]
            }).then(res => {
              that.options = res.data.list;

              vsTree({
                saiqu:that.queryParam.sjsq[1],
                subject:'1.1'
              }).then(res => {
                that.treeData = res.data.tree;
                that.levels = res.data.levels;


                that.width = Math.pow(2,that.levels-1)*140
                that.height = 220*that.levels;

                setTimeout(() =>{
                  that.initDrag()
                },100)
              });
    
            });
          }, 
          initDrag(){
            let that = this;
            var drops=document.querySelectorAll('.duiwu-item');
            
            var prc=[];

            console.log('drops',drops)

            drops.forEach((drop) =>{
              drop.addEventListener('dragstart',function(e){
                  console.log('开始拖动');
                  //将拖动元素放进数组
                  prc[0]=drop;
                  //设置需要传递的数据
                  e.dataTransfer.setData('xid',drop.getAttribute('xid'));
                  //这两项都必须设置成move，被拖动目标才能放进放置目标中
                  e.dataTransfer.dropEffect="move";
                  e.dataTransfer.effectAllowed="move";

              });
              drop.addEventListener('drag',function(){
                  // console.log('拖动中');
              });

              drop.addEventListener('dragend',function(event){
                  console.log('拖动结束');
              });


            })
             
            var containers=document.querySelectorAll(".group-item");
            console.log('containers',containers)
            containers.forEach((container) =>{
              console.log('container',container)
              container.addEventListener('dragenter',function(){
                  console.log('源对象进入目标对象');
              });
              container.addEventListener('dragover',function(e){
                  e.preventDefault();
                  console.log('源对象悬停目标对象');
              });
              container.addEventListener('dragleave',function(){
                  console.log('源对象离开目标对象');
              });
              container.addEventListener('drop',function(e){
                let subject_id= container.getAttribute('subject_id'); 
                let indexId= container.getAttribute('index');
                let nid= container.getAttribute('nid');
                  console.log('源对象释放目标对象',container.getAttribute('xid'),e);
                if(subject_id>0){
                  return false;
                }
                let from_xid = e.dataTransfer.getData('xid');

                let duiwu = that.options.filter(item =>{
                  return item.id == from_xid
                });
                if(duiwu.length==0){
                  return 
                }

                that.updateNode(that.treeData,nid,indexId,duiwu[0]);  
                that.options = that.options.filter(item =>{
                  return item.id != from_xid
                }); 

                that.setTreeNode(duiwu[0].id,nid,indexId)
                  //得到数据
                  
                console.log('xid',e.dataTransfer.getData('xid'));
                  //将拖动目标添加到放置目标当中
                  // this.appendChild(prc[0]);
              });

            })
    },

    setTreeNode(subject_id,id,index){
      let that = this
      setTreeNode({ 
        id,subject_id,index
      }).then(res => {
        that.$message.success('设置成功');   
      }).catch(err => {
        that.$message.error(err.data.msg); 
      })
    },

    // 增改 处理
    handleOk(e) {
      let that = this;
      // console.log('')
      // e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {      
          createVsTree({  
            levels: values.count,
            subject:'1.1',
            subject_name:'男子网毽',
            saiqu: that.formData.saiqu,   
          }).then(res => {
            that.$message.success('创建成功'); 

            that.saveLoading = false;
            that.getOptions()
          }).catch(err => {
            that.$message.error(err.data.msg);
            that.saveLoading = false;
          })  
          this.visible = false;
        }
      })
    },
    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

    }

  }
</script>

<style lang="less" scoped>
  .card-list{
    display: flex;
  }
  .card-avatar {
    width: 48px;
    height: 48px;
    border-radius: 48px;
  }

  .ant-card-actions {
    background: #f7f9fa;
  li {
    float: left;
    text-align: center;
    margin: 12px 0;
    color: rgba(0, 0, 0, 0.45);
    width: 50%;

  &:not(:last-child) {
     border-right: 1px solid #e8e8e8;
   }

  a {
    color: rgba(0, 0, 0, .45);
    line-height: 22px;
    display: inline-block;
    width: 100%;
  &:hover {
     color: #1890ff;
   }
  }
  }
  }

  .new-btn {
    background-color: #fff;
    border-radius: 2px;
    width: 100%;
    height: 188px;
  }

  .meta-content {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    // height: 64px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .group-item{
    margin: 10px ;
    height: 80px;
    border: 1px solid #ccc;
  }
  .duiwu-item{
    margin: 10px ;
    min-height: 80px;
    cursor: move;
    border-bottom: 1px solid #ccc;
  }
</style>